
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[url]",
      function () {
        return require("private-next-pages/product/[url].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[url]"])
      });
    }
  